import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getCalculationGuests } from 'modules/accommodations/features/reservations/api';

type TCalculationGuests = {
  reservationId: string;
  enabled: boolean;
};

export const useQueryCalculationGuests = ({ reservationId, enabled }: TCalculationGuests) =>
  useQuery(
    [QUERY_KEYS.RENTALS_CALCULATION_GUESTS, reservationId],
    () => getCalculationGuests(reservationId),
    { enabled },
  );
